import graphql__0290ef84f9d8b895e2a4 from "./__generated__/StartFormMutation.graphql.js";import { commitMutation } from "react-relay";
import { graphql } from "react-relay";
import appRelayEnvironment from "../config/AppRelayEnvironment";

const mutation = graphql__0290ef84f9d8b895e2a4;

function startForm(variables, onCompleted) {
  return commitMutation(appRelayEnvironment, {
    mutation,
    variables,
    onCompleted,
    onError: error => console.error(error)
  });
}

export { startForm };
